@if (isPolicyPrevidenziale) {
  <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
    <h6>{{ formTitle }}</h6>
  </div>
  <app-assets-table [assets]="validAddress" [tableKeys]="tableKeys" [isReadOnly]="true"></app-assets-table>
  <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
} @else {
  <app-basic-card>
    <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
      <h6>{{ formTitle }}</h6>
    </div>
    <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
</app-basic-card>
<div class="mt-4" *ngIf="additionalForm && !isAddressForGianos">
    <app-basic-card>
      <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
        <h6>{{ additionalFormTitle }}:</h6>
      </div>
      <app-basic-form
        [form]="additionalForm"
        [keys]="additionalFormKeys"
      ></app-basic-form>
    </app-basic-card>
  </div>
}
